<script>
	import delve from 'dlv'
	import FocusLocker from 'focus-locker'
	import { fade, fly } from 'svelte/transition'
	import { createEventDispatcher } from 'svelte'

	const { jQuery, wc_cart_fragments_params } = window

	//generic modal
	const dispatch = createEventDispatcher()

	const addQtyButton = jQuery('#add_qty')
	// const minusQtyButton = jQuery('#minus_qty')
	const qtyField = jQuery('input[type=number].qty')
	// const addToCartButton = jQuery('.single_add_to_cart_button')
	const productForm = jQuery('.variations_form')

	jQuery('.woocommerce-variation-add-to-cart')
	// .detach()
	// .prependTo('#single-btn-wrap')

	// qtyField.detach().insertAfter(minusQtyButton)

	// const { logoAddToCart } = window.modal_object
	let modal
	let modalContent

	// addQtyButton.on('click', function() {
	// 	let curQty = qtyField.val()
	// 	let newQty = Number(curQty) + 1
	// 	qtyField.val(Math.max(1, Math.min(99, newQty)))
	// })

	// minusQtyButton.on('click', function() {
	// 	let curQty = qtyField.val()
	// 	let newQty = Number(curQty) - 1
	// 	qtyField.val(Math.max(1, Math.min(99, newQty)))
	// })

	qtyField.on('keyup mouseup', function() {
		let newQty = qtyField.val()
		qtyField.val(Math.max(1, Math.min(99, newQty)))
	})

	productForm.on('submit', function(e) {
		e.preventDefault()
		let data = {
			action: 'woocommerce_ajax_add_to_cart',
			product_id: productForm.data('product_id'),
			quantity: qtyField.val(),
		}

		// get selected variations
		let variation = {}
		data.variation_id = jQuery('[name=variation_id]').val()
		jQuery('.variations_form .variations select').each(function(i, el) {
			let val = jQuery(el)
				.find('option:selected')
				.val()
			let name = el.getAttribute('name')
			if (!val || !name) {
				failedValidation = true
			}
			variation[name] = val
		})
		data.variation = variation

		sendAddToCartRequest(data)
	})

	function sendAddToCartRequest(data) {
		jQuery.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data,
			success: response => {
				if (response.error & response.product_url) {
					window.location = response.product_url
					return
				}
				let content = delve(response, [
					'fragments',
					'div.widget_shopping_cart_content',
				])
				if (content) {
					modalContent = content
				} else {
					window.location.href = '/cart/'
				}
				// update cart icon item num
				let cartCountHTML = delve(response, ['fragments', '#cart_count'])
				if (cartCountHTML) {
					jQuery('#cart_count')[0].outerHTML = cartCountHTML
				}
			},
		})
	}

	const onClose = () => {
		// hide scrollbars
		// document.documentElement.style.overflowY = 'hidden'
		// document.body.style.overflowY = 'scroll'
		// focus trap to modal
		FocusLocker.request(modal)
	}

	const onShow = () => {
		// show scrollbars
		dispatch('mount')
		// document.documentElement.style.overflowY = 'auto'
		// document.body.style.overflowY = 'auto'
		// restore trapped focus
		FocusLocker.release()
	}

	const wrapClick = e => e.target === e.currentTarget && hideModal()

	function hideModal() {
		modalContent = null
	}
</script>

{#if modalContent}
	<div
		class="svelte-modal-wrap login-modal shop-modal"
		data-slideout-ignore
		on:click={wrapClick}
		transition:fade={{ duration: 300 }}
		on:introstart={onClose}
		on:outroend={onShow}>
		<div class="main">
			<div class="inner-wrap">
				<div
					class="svelte-modal"
					in:fly={{ y: 10 }}
					out:fly={{ y: -10 }}
					bind:this={modal}>
					<div class="modal-inner">
						<div class="modal-head">
							<h2>Shopping Cart</h2>
							<button class="close-modal" on:click={hideModal}>
								<svg
									xmlns="http://www.w3.org/2000/svg"
									viewBox="0 0 47.971 47.971">
									<path
										d="M28.228 23.986L47.092 5.122a2.998 2.998 0 0 0 0-4.242
										2.998 2.998 0 0 0-4.242 0L23.986 19.744 5.121.88a2.998 2.998
										0 0 0-4.242 0 2.998 2.998 0 0 0 0 4.242l18.865 18.864L.879
										42.85a2.998 2.998 0 1 0 4.242 4.241l18.865-18.864L42.85
										47.091c.586.586 1.354.879 2.121.879s1.535-.293
										2.121-.879a2.998 2.998 0 0 0 0-4.242L28.228 23.986z" />
								</svg>
								<span class="sr-only">Close Modal</span>
							</button>
						</div>
						<div class="modal-body">
							{@html modalContent}
							<a href="/shop/" class="keep-shopping">Keep Shopping</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
{/if}
